import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loading } from "../nav/Loading";
import { UserContext } from "./UserProvider";
export const PrivateRoute = ({ children, }) => {
    const location = useLocation();
    const { user, loading } = useContext(UserContext);
    if (loading) {
        return _jsx(Loading, {});
    }
    if (user === null) {
        return (_jsx(Navigate, { to: "/login", state: {
                from: `${location.pathname}${location.search}${location.hash}`,
            }, replace: true }));
    }
    return children;
};
